import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const RelatedPredictions = ({ predictions, onViewPrediction }) => {
  const getConfidenceColor = (confidence) => {
    if (confidence >= 80) return 'text-success';
    if (confidence >= 60) return 'text-warning';
    return 'text-error';
  };

  const getPredictionIcon = (trend) => {
    if (trend === 'Bullish') return 'TrendingUp';
    if (trend === 'Bearish') return 'TrendingDown';
    return 'Minus';
  };

  const getPredictionColor = (trend) => {
    if (trend === 'Bullish') return 'text-success';
    if (trend === 'Bearish') return 'text-error';
    return 'text-warning';
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 shadow-elevation-2">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center space-x-3">
          <Icon name="Layers" size={24} className="text-primary" />
          <h3 className="text-xl font-semibold text-card-foreground">Related Predictions</h3>
        </div>
        <Button variant="outline" size="sm" onClick={() => window.location.href = '/ai-predictions-detail'}>
          View All
        </Button>
      </div>
      <div className="space-y-4">
        {predictions?.map((prediction) => (
          <div 
            key={prediction?.id} 
            className="flex items-center justify-between p-4 bg-muted rounded-lg hover:bg-muted/80 transition-standard cursor-pointer"
            onClick={() => onViewPrediction(prediction)}
          >
            <div className="flex items-center space-x-4">
              <div className="w-10 h-10 bg-primary rounded-full flex items-center justify-center">
                <span className="text-white font-bold text-sm">
                  {prediction?.symbol?.slice(0, 2)}
                </span>
              </div>
              <div>
                <div className="flex items-center space-x-2 mb-1">
                  <p className="font-medium text-card-foreground">{prediction?.name}</p>
                  <span className="text-sm text-muted-foreground">({prediction?.symbol})</span>
                </div>
                <div className="flex items-center space-x-4 text-sm text-muted-foreground">
                  <span>Target: ${prediction?.priceTarget?.toLocaleString()}</span>
                  <span>•</span>
                  <span>{prediction?.timeframe}</span>
                </div>
              </div>
            </div>

            <div className="flex items-center space-x-4">
              <div className="text-right">
                <div className="flex items-center space-x-2 mb-1">
                  <Icon 
                    name={getPredictionIcon(prediction?.trend)} 
                    size={16} 
                    className={getPredictionColor(prediction?.trend)} 
                  />
                  <span className={`text-sm font-medium ${getPredictionColor(prediction?.trend)}`}>
                    {prediction?.trend}
                  </span>
                </div>
                <p className={`text-sm ${getConfidenceColor(prediction?.confidence)}`}>
                  {prediction?.confidence}% confidence
                </p>
              </div>
              <Icon name="ChevronRight" size={20} className="text-muted-foreground" />
            </div>
          </div>
        ))}
      </div>
      <div className="mt-6 p-4 bg-primary/10 rounded-lg border border-primary/20">
        <div className="flex items-start space-x-3">
          <Icon name="Sparkles" size={20} className="text-primary mt-0.5" />
          <div>
            <h5 className="font-medium text-card-foreground mb-1">AI Recommendation</h5>
            <p className="text-sm text-muted-foreground">
              Based on current market conditions and correlation analysis, consider diversifying 
              your portfolio with these related cryptocurrencies for optimal risk management.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RelatedPredictions;